import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/userSlice';
import { authService } from '../../services/apiService';

const LoginTest: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setResult('');

    try {
      console.log('Attempting login with:', { email, password });
      
      const data = await authService.login({
        username: email,
        password,
      });

      console.log('Login successful:', data);
      
      // Set user in Redux store
      dispatch(
        setUser({
          email: data.user.email,
          role: data.user.role,
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          companyId: data.user.companyId,
          token: data.token,
          refreshToken: data.refreshToken,
        }),
      );

      setResult(`Login successful! User: ${data.user.email}, Role: ${data.user.role}, Token length: ${data.token.length}`);
      
      // Store in localStorage for debugging
      localStorage.setItem('debug_user', JSON.stringify(data));
      
    } catch (error) {
      console.error('Login error:', error);
      setResult(`Login failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  const checkStoredUser = () => {
    const storedUser = localStorage.getItem('user');
    const debugUser = localStorage.getItem('debug_user');
    
    setResult(`
Stored user: ${storedUser ? 'Yes' : 'No'}
Debug user: ${debugUser ? 'Yes' : 'No'}
${storedUser ? `Stored user data: ${storedUser}` : ''}
${debugUser ? `Debug user data: ${debugUser}` : ''}
    `);
  };

  const clearStorage = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('debug_user');
    setResult('Storage cleared');
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-4">Login Test</h1>
      
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-400"
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      <div className="mt-4 space-y-2">
        <button
          onClick={checkStoredUser}
          className="w-full p-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Check Stored User
        </button>
        
        <button
          onClick={clearStorage}
          className="w-full p-2 bg-red-500 text-white rounded hover:bg-red-600"
        >
          Clear Storage
        </button>
      </div>

      {result && (
        <div className="mt-4 p-4 bg-gray-100 rounded">
          <h3 className="font-medium mb-2">Result:</h3>
          <pre className="text-xs whitespace-pre-wrap">{result}</pre>
        </div>
      )}
    </div>
  );
};

export default LoginTest; 